import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, DialogContainer, SelectField, TextField } from "react-md";
import "../styles/createAccountStyles.css";
import FontIcon from "react-md/lib/FontIcons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import AssignUtils from "../services/AssignUtils";
import EventService from "../../../../../service/event/EventService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Checkbox, Radio } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PaginationBridge from "../helper/PaginationBridge";

export const AssignPlansOnPid = (props) => {
  const history = useHistory();
  const [pid, setPid] = useState(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const [accountsOnPid, setAccountsOnPid] = useState([]);
  const [accountRadioSelected, setAccountRadioSelected] = useState("");
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingTable2, setLoadingTable2] = useState(false);
  const [plansOnAccount, setPlansOnAccount] = useState([]);
  const [loadingPlansTable, setLoadingPlansTable] = useState(false);
  const [plansSelected, setPlansSelected] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [plansOnPid, setPlansOnPid] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPlansAssignedDialog, setOpenPlansAssignedDialog] = useState(false);
  const [plansAssignmentResponse, setPlansAssignmentResponse] = useState([]);
  const assignUtils = new AssignUtils();

  const PAGE_SIZE = 30;

  useEffect(() => {
    const path = history.location.pathname;
    const match = path.match(/\/assign-plan\/(\d+)/);

    const id = match ? match[1] : null;

    if (id != null) {
      setPid(id);
      getPatientDetails(id);
      fetchPlansOnPatientId(id);
      fetchActiveAccountsOnPatientId(id);
    }
  }, []);
  useEffect(() => {
    if (accountRadioSelected != "") {
      getAssignedPlansByFilter(accountRadioSelected);
      setPlansSelected([]);
    }
  }, [accountRadioSelected]);
  useEffect(() => {
    setCurrentPage(0);
  }, [plansOnAccount]);

  const getPatientDetails = (id) => {
    const onResponse = (res) => {
      setPatientDetails(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    assignUtils.fetchPatientId(id, onResponse, onError);
  };
  const fetchPlansOnPatientId = (id) => {
    setLoadingTable2(true);
    const onResponse = (res) => {
      setLoadingTable2(false);
      setPlansOnPid(res == null || res.length == 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingTable2(false);
    };

    assignUtils.getPlansForPid2(id, onResponse, onError);
  };
  const fetchActiveAccountsOnPatientId = (id) => {
    setLoadingTable(true);
    const onResponse = (res) => {
      setLoadingTable(false);
      setAccountsOnPid(
        res === null ||
          res.patientAccounts === null ||
          res.patientAccounts.length === 0
          ? []
          : res.patientAccounts
      );
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingTable(false);
    };

    assignUtils.fetchActiveAccountsOnPatientId(id, onResponse, onError);
  };

  const assignPlans = () => {
    if (pid == null) {
      EventService.emit("showError", {
        message: `Patient ID is null`,
      });
      return;
    } else if (accountRadioSelected == "") {
      EventService.emit("showError", {
        message: `Please select some account`,
      });
      return;
    } else if (plansSelected.length == 0) {
      EventService.emit("showError", {
        message: `Please select some plan`,
      });
      return;
    } else {
      let body = {
        patientId: Number(pid),
        planIds: plansSelected,
      };
      setLoading(true);
      const onResponse = (res) => {
        setLoading(false);
        setPlansAssignmentResponse(res.length == 0 ? [] : res);
        setOpenPlansAssignedDialog(true);
      };
      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      };

      assignUtils.assignPlansToPid(body, onResponse, onError);
    }
  };
  const handleSelectAccountRadio = (event) => {
    setAccountRadioSelected(event.target.value);
  };
  const ZypleRadio = withStyles({
    root: {
      color: "#6A5FF5",
      padding: 0,
      margin: 0,
      "&$checked": {
        color: "#6A5FF5",
      },
    },
    checked: {},
  })((props) => <Radio disableRipple {...props} />);

  const getAssignedPlansByFilter = (accountCode) => {
    setLoadingPlansTable(true);
    let body = {
      pageNum: 0,
      pageSize: 0,
      accountCodes: [accountCode],
      status: 1,
    };
    const onResponse = (res) => {
      setPlansOnAccount(
        res === null || res.plans === null || res.plans.length == 0
          ? []
          : res.plans
      );
      setLoadingPlansTable(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingPlansTable(false);
    };
    assignUtils.getAssignedPlansByFilter(body, onResponse, onError);
  };
  const isPlanSelected = (id) => plansSelected.includes(id);
  const handlePlanSelection = (id) => {
    setPlansSelected((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };
  const paginatedPlans = plansOnAccount.slice(
    currentPage * PAGE_SIZE,
    currentPage * PAGE_SIZE + PAGE_SIZE
  );

  const isPlanAlreadyAssigned = (planID) => {
    return plansOnPid.some(
      (e) =>
        e.patientPlanInfo.planId == planID &&
        e.patientPlanInfo.currentPlanStatus == 3
    );
  };

  const exitPage = () => {
    setOpenPlansAssignedDialog(false);
    setPlansAssignmentResponse([]);
    setPid(null);
    setPatientDetails(null);
    setAccountsOnPid([]);
    setAccountRadioSelected("");
    setLoadingTable(false);
    setLoadingTable2(false);
    setPlansOnAccount([]);
    setLoadingPlansTable(false);
    setPlansSelected([]);
    setCurrentPage(0);
    setPlansOnPid([]);
    setLoading(false);
    // history.go(-1);
    history.push(`/assigned-plans/${pid}`);
  };

  return (
    <div className="account-module-page-padding">
      {patientDetails == null ? (
        <></>
      ) : (
        <>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="account-module-view">
                <div className="account-module-heading-with-back-button">
                  <div
                    className="account-module-back-btn"
                    onClick={() => {
                      exitPage();
                    }}
                  >
                    <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
                  </div>
                  <h1>{`Assign plan`}</h1>
                </div>
                <div className="account-module-buttons-container">
                  <div className="account-module-buttons-right-alignment">
                    <Button
                      raised
                      disabled={loading}
                      className={
                        loading
                          ? "account-module-button-save-disabled"
                          : "account-module-button-save-enabled"
                      }
                      onClick={() => {
                        assignPlans();
                      }}
                    >
                      {"Assign"}
                    </Button>

                    <Button
                      raised
                      disabled={loading}
                      className="account-module-button-cancel"
                      onClick={() => {
                        exitPage();
                      }}
                    >
                      {"Cancel"}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <div className="account-module-grey-heading">Patient details</div>
          <br />
          <div className="account-module-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="account-module-create-service-field-container">
                  <div className="account-module-label">{`Patient ID`}</div>
                  <div>
                    <TextField
                      value={patientDetails?.id}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="account-module-create-service-field-container">
                  <div className="account-module-label">{`Patient name`}</div>
                  <div>
                    <TextField
                      value={`${patientDetails?.firstName} ${patientDetails?.lastName}`}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <div>
            <h3>Select accounts</h3>
          </div>
          <br />
          <div className="account-module-table-container">
            <div className="table">
              <div className="table-header2">User's active accounts</div>
              <div className="table-row1 table-header3">
                <div className="table-cell" style={{ width: "5%" }}></div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Account ID
                </div>
                <div className="table-cell" style={{ width: "25%" }}>
                  Account name
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Account type
                </div>
                <div className="table-cell" style={{ width: "20%" }}>
                  KAM
                </div>
                <div className="table-cell" style={{ width: "20%" }}>
                  Plan status
                </div>
              </div>
              {loadingTable || loadingTable2 ? (
                <GlobalSkeletonLoader />
              ) : accountsOnPid.length == 0 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      No records to show
                    </div>
                    <img src={NoRecordsIcon} width={50} height={62} />
                  </div>
                </div>
              ) : (
                accountsOnPid.map((acc) => {
                  return (
                    <div className="table-row1">
                      <div className="table-cell" style={{ width: "5%" }}>
                        {
                          <ZypleRadio
                            checked={accountRadioSelected === acc.accountCode}
                            onChange={handleSelectAccountRadio}
                            value={acc.accountCode}
                            name="mp-select-account-radio"
                            inputProps={{ "aria-label": `${acc.accountName}` }}
                          />
                        }
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {acc.accountCode}
                      </div>
                      <div className="table-cell" style={{ width: "25%" }}>
                        {acc.accountName}
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {acc.mode}
                      </div>
                      <div className="table-cell" style={{ width: "20%" }}>
                        {acc.managerName}
                      </div>
                      <div className="table-cell" style={{ width: "20%" }}>
                        <div
                          className="status-select-active"
                          style={{
                            height: "25px",
                            width: "fit-content",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          {acc.patientStatus === true ? "Active" : "-"}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>

          {accountRadioSelected != "" && loadingPlansTable == false && (
            <>
              <br />
              <div>
                <h3>Active plans on selected accounts</h3>
              </div>
              <br />
              <div className="account-module-table-container">
                <div className="table">
                  <div className="table-row1 table-header3">
                    <div className="table-cell" style={{ width: "5%" }}></div>
                    <div className="table-cell" style={{ width: "13%" }}>
                      Plan ID
                    </div>
                    <div className="table-cell" style={{ width: "20%" }}>
                      Plan name
                    </div>
                    <div className="table-cell" style={{ width: "13%" }}>
                      Created date
                    </div>
                    <div className="table-cell-right" style={{ width: "10%" }}>
                      Plan price
                    </div>
                    <div className="table-cell" style={{ width: "13%" }}>
                      Plan duration
                    </div>
                    <div className="table-cell" style={{ width: "13%" }}>
                      Plan start date
                    </div>
                    <div className="table-cell" style={{ width: "13%" }}>
                      Plan end date
                    </div>
                  </div>
                  <div className="table-row-rev">
                    <PaginationBridge
                      initialPageNum={0}
                      initialTotalCount={plansOnAccount.length}
                      initialPageSize={PAGE_SIZE}
                      onPageChange={(page, start, end) => {
                        setCurrentPage(page);
                        console.log(
                          `Showing page ${page + 1}: items ${start} to ${end}`
                        );
                      }}
                    />
                  </div>
                  {loadingPlansTable ? (
                    <GlobalSkeletonLoader />
                  ) : plansOnAccount.length == 0 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ marginBottom: "20px" }}>
                          No records to show
                        </div>
                        <img src={NoRecordsIcon} width={50} height={62} />
                      </div>
                    </div>
                  ) : (
                    paginatedPlans.map((plan) => {
                      return (
                        <div className="table-row1">
                          <div className="table-cell" style={{ width: "5%" }}>
                            {
                              <Checkbox
                                id={`mp-plan-to-assign-select-${plan.id}`}
                                name={`mp-plan-to-assign-select-${plan.id}`}
                                disabled={isPlanAlreadyAssigned(plan.id)}
                                color={
                                  isPlanAlreadyAssigned(plan.id)
                                    ? "default"
                                    : "secondary"
                                }
                                checked={
                                  isPlanAlreadyAssigned(plan.id)
                                    ? true
                                    : isPlanSelected(plan.id)
                                }
                                style={{ margin: "0px", padding: "0px" }}
                                onChange={() => handlePlanSelection(plan.id)}
                              />
                            }
                          </div>
                          <div className="table-cell" style={{ width: "13%" }}>
                            {plan.id}
                          </div>
                          <div className="table-cell" style={{ width: "20%" }}>
                            {plan.basicDetails.name}
                          </div>
                          <div className="table-cell" style={{ width: "13%" }}>
                            {moment.utc(plan.createdAt).format("DD MMM YYYY")}
                          </div>
                          <div
                            className="table-cell-right"
                            style={{ width: "10%" }}
                          >
                            {plan.basicDetails.price}
                          </div>
                          <div className="table-cell" style={{ width: "13%" }}>
                            {`${plan.basicDetails.duration} days`}
                          </div>
                          <div className="table-cell" style={{ width: "13%" }}>
                            {moment
                              .utc(plan.basicDetails.startDate)
                              .isSame(moment.utc("0001-01-01T00:00:00Z"))
                              ? "NA"
                              : moment
                                  .utc(plan.basicDetails.startDate)
                                  .format("DD MMM YYYY")}
                          </div>
                          <div className="table-cell" style={{ width: "13%" }}>
                            {moment
                              .utc(plan.basicDetails.endDate)
                              .isSame(moment.utc("0001-01-01T00:00:00Z"))
                              ? "NA"
                              : moment
                                  .utc(plan.basicDetails.endDate)
                                  .format("DD MMM YYYY")}
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
      {openPlansAssignedDialog && (
        <DialogContainer
          id="plan-patient-assigned-dialog"
          visible={openPlansAssignedDialog}
          focusOnMount={false}
          onHide={() => {}}
          width="820px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="account-module-confirm-diaglog">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h3>Assigned plans response</h3>
              </div>
              <div>
                <Button
                  raised
                  className={"account-module-button-save-enabled"}
                  onClick={() => {
                    exitPage();

                    // if (plansAssignmentResponse.some((e) => e.error != "")) {
                    //   setOpenPlansAssignedDialog(false);
                    //   setPlansAssignmentResponse([]);
                    //   setAccountRadioSelected("");
                    //   setPlansSelected([]);
                    //   setCurrentPage(0);
                    //   fetchPlansOnPatientId(pid);
                    // } else {
                    //   exitPage();
                    // }
                  }}
                >
                  {"OK"}
                </Button>
              </div>
            </div>
            <br />
            <Row>
              <Col xs={2} sm={2} md={2} lg={2}>
                <div style={{ fontWeight: "bold" }}> {"Plan ID"}</div>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2}>
                <div style={{ fontWeight: "bold" }}> {"Result"}</div>
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <div style={{ fontWeight: "bold" }}> {"Message"}</div>
              </Col>
            </Row>
            <br />
            {plansSelected.map((e, index) => {
              return (
                <>
                  <Row>
                    <Col xs={2} sm={2} md={2} lg={2}>
                      {e}
                    </Col>
                    <Col xs={2} sm={2} md={2} lg={2}>
                      <div
                        style={
                          plansAssignmentResponse[index].error == ""
                            ? {
                                fontWeight: "bold",
                                backgroundColor: "#caecde",
                                color: "#0b5033",
                                padding: "3px",
                                textAlign: "center",
                                borderRadius: "5px",
                              }
                            : {
                                fontWeight: "bold",
                                backgroundColor: "#fbdfd9",
                                color: "#e44437",
                                padding: "3px",
                                textAlign: "center",
                                borderRadius: "5px",
                              }
                        }
                      >
                        {plansAssignmentResponse[index].error == ""
                          ? "Assigned"
                          : "Error"}
                      </div>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8}>
                      {plansAssignmentResponse[index].error == ""
                        ? "Success"
                        : plansAssignmentResponse[index].error}
                    </Col>
                  </Row>
                  <br />
                </>
              );
            })}
          </div>
        </DialogContainer>
      )}
    </div>
  );
};

export default AssignPlansOnPid;
